import { ERecieveMethod, TPickupPointProvider } from 'models/orders'

export const getDeliveryTypeName = (
  type: keyof typeof ERecieveMethod,
  pickupPointProvider?: TPickupPointProvider,
  pickupPointName?: string
): string => {
  switch (type) {
  case ERecieveMethod.COURIER:
    return 'Доставка курьером СДЭК'
  case ERecieveMethod.PICKUP_POINT:
    return 'Самовывоз из магазина'
  case ERecieveMethod.EXPRESS:
    return 'Яндекс экспресс доставка'
  case ERecieveMethod.OWN_DELIVERY:
    return 'Самостоятельная доставка'
  case ERecieveMethod.PVZ:
    if (pickupPointProvider === 'YANDEX' && /\b5\s*post\b|пят[её]роч/i.test(pickupPointName ?? '')) {
      return 'Доставка в пункт выдачи 5Post (Пятёрочка)'
    }
    return pickupPointProvider === 'YANDEX'
      ? 'Доставка в пункт выдачи Яндекс'
      : 'Доставка в пункт выдачи СДЭК'
  default:
    return 'Доставка'
  }
}
